import { useEffect, useState } from 'react';
import { Button, Col, Collapse, DatePicker, Form, Input, Row, Select,Pagination,Spin } from 'antd';
import {  AiOutlinePrinter, AiOutlineSearch, AiOutlineSync,AiOutlineRight,AiOutlineDown  } from 'react-icons/ai';
import MessageCommon from '../../enum/Message';
import { Label } from 'reactstrap';
import {RequestType, RequestTypeOption, CartonStatus, ExportType} from '../../enum';
import { QueryDataModel ,Parameter ,Item, User, Option} from '../../models'
import { Helper, InitHelper,StickyHelper } from '../../helpers';
import { HrWebService, QueryService, PropertyService, WarehouseService, FileManageService} from '../../services';
import dayjs from 'dayjs'
import { EmployeeAutoComplete } from '../../autocomplete/EmployeeAutoComplete'
import { OrgUnitAutoComplete } from '../../autocomplete/OrgUnitAutoComplete';
import secureLocalStorage  from  "react-secure-storage";
import Loading from '../../components/Loading';
import { apiRequest } from "../../configurations/authConfig";
import { useMsal } from "@azure/msal-react";

interface AppState {
  currentPage:number
  perpage:number
  total: number
  totalPgae: number
  items:QueryDataModel[]
  isLoading:boolean
}

const ReportAllTransaction = () => {
  const stickyHelper = new StickyHelper('report-all-transaction',50,50)
  stickyHelper.setMinHight(900)
  const stickyElement = stickyHelper.getElement()
    const { instance, accounts } = useMsal();
    const userStore = secureLocalStorage.getItem('user')
    const user:User = userStore ? JSON.parse(userStore.toString()): null
    const pageSizeOptions = user.systemConfig.tablePageSize
    
  const [dataForm] = Form.useForm();
  const { Panel } = Collapse;
  const initialRequestTypeIds:number[] = [
    RequestType.NewCarton, 
    RequestType.StorageCarton, 
    RequestType.CollectCarton,
    RequestType.ReturnCarton,  
    RequestType.RemoveCartonStorage,
    RequestType.ExtendCarton, 
    RequestType.DestructionCarton
  ]
 
  const [requestTypeId,setRequestTypeId] = useState(0)
  const [requestTypeIds,setRequestTypeIds] = useState<number[]>(initialRequestTypeIds)
  const [requestStartDate, setRequestStartDate] = useState<Date|null>(null);
  const [requestEndDate, setRequestEndDate] =  useState<Date|null>(null);
  const [warehouseOptions, setWarehouseOptions] = useState<Option[]>([]) 
  const [warehouseId, setWarehouseId] = useState("")
  const [appState,setAppState] = useState<AppState>({
    currentPage : 1,
    total : 0,
    totalPgae : 0,
    perpage: 10,
    items: [],
    isLoading : true
  })
  const [saveParameter,setSaveParameter] = useState<Parameter>(InitHelper.InitialParameter())
  const [requesters, setRequesters] = useState<Item[]>([])
  const [owners, setOwners] = useState<Item[]>([])
  const [orgunits, setOrgUnits] = useState<Item[]>([])
  const [isPrint,setIsprint] = useState(true)
  const [isLoadingPrint,setIsLoadingPrint] = useState(false)
  const [clientHeight,setClientHeight] = useState(0)

  const onFinish = (values: any) => {
  };

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };
 

  const onRequestTypeChange = (_requestTypeId: number) => {
    if(_requestTypeId === 0){
      setRequestTypeIds(initialRequestTypeIds)
    }
    else{
      setRequestTypeIds([_requestTypeId])
    }
    
  };

  const getData = async (currentPage: number,perpage: number,_parameter:Parameter | null = null,print:boolean = true) => {
    let _state:AppState = Object.assign({},appState)
       _state.isLoading = true
       setAppState(_state)

    let parameter = Object.assign({},saveParameter)
    if(_parameter !== null){
        parameter = Object.assign({},_parameter);
    }
    
      parameter.page = currentPage
      parameter.limit = perpage
      parameter.onBehalf = -1
      parameter.distinctBy ="cartonNo"
     
      let token = await getToken()
      try{
        let result = await new QueryService(token).SearchTransaction(parameter)
      
        if(result && result.success)
        {
          let state = Object.assign({},appState)
          state.total = result.data.total
          state.currentPage = currentPage
            state.perpage = perpage

            result.data.items.forEach((item: QueryDataModel) => {
                item.requestType = (item.requestType === "Extend Carton" ? "Destruction Carton" : item.requestType);
            })

          state.items = result.data.items
          state.isLoading = false
        
          if(result.data.total>0 && print){
            setIsprint(false)
          }else{
            setIsprint(true)
          }
        
          setTimeout(() => {
            setSaveParameter(parameter)
            setAppState(state)
            setTimeout(() => {
              onSetClientHeight()
            }, 100);
          }, 500);
        }
        else{
          let state = Object.assign({},appState)
          state.total = 0
        state.items = []
          state.isLoading = false
          setAppState(state)
        }
      }
      catch(error)
      {
        console.log(error)
        let state = Object.assign({},appState)
        state.total = 0
        state.items = []

          state.isLoading = false
          setAppState(state)
      }
      
      

  }

  const onRequesterSelect = (item:any) => {
    setRequesters(item)
    stickyHelper.updatePosition()
  }
  
  const onOwnerSelect = (item:any) => {
    setOwners(item)
    stickyHelper.updatePosition()
  }

  const onOrgUnitSelect = (item:any) => {
    setOrgUnits(item)
    stickyHelper.updatePosition()
  }
  
  const onSearchEmployee = async(key:string) => {
   
      let token = await getToken()
      let result = await new HrWebService(token).SearchEmployee2(key)
      if(result && result.success)
      {
        return result.data
      }
      else{
        console.log(result?.message)
        return []
      }
  }

  const onSearchOrgUnit = async(key:string) => {
   
    let token = await getToken()
    let result = await new PropertyService(token).GetOrgUnits(key)
    if(result && result.success)
    {
      return result.data
    }
    else{
      console.log(result?.message)
      return []
    }
}

    const getWarehouses = async () => {
        let token = await getToken()
        let result = await new WarehouseService(token).GetAllWarehouses()
        if (result && result.success) {
            let options: Option[] = [{ label: 'All', value: '' }]
            let Locationoptions: Option[] = result.data.map((item) => { return { value: item.warehouseName, label: item.warehouseName } })
            setWarehouseOptions(options.concat(Locationoptions))
        }
    }

    const onSetClientHeight = () => {
    
      setTimeout(() => {
        stickyHelper.updatePosition()
        window.scrollTo(0,0)
        let element = document.getElementById(stickyElement.container) as HTMLInputElement
        if(element){
          let value = element.clientHeight
          setClientHeight(value)
        }
      }, 100);
    
    }

    useEffect(() => {
    
        getWarehouses()
      
    let parameter = Object.assign({},InitHelper.InitialParameter())
    parameter.requestTypeIds = initialRequestTypeIds
    parameter.statusIds = [
        CartonStatus.WaitApproval,
        CartonStatus.WaitAdmin,
        CartonStatus.Inprogress,
        CartonStatus.Cancel,
        CartonStatus.Reject,
        CartonStatus.Approve,
        CartonStatus.Done
    ]
 
    getData(1,appState.perpage,parameter,false).then(() => {
      stickyHelper.updatePosition()
  
    })

    stickyHelper.removeEvent()
    stickyHelper.addEvent()
    window.addEventListener("resize", () => { 
      onSetClientHeight()
  });
  }, [])

    const getToken = async () => {
        const acc = accounts && accounts.length ? accounts[0] : null;
        apiRequest.scopes[0] = "api://" + secureLocalStorage.getItem('clientId') + "/read_user_profile"
        if (acc) {
            const { accessToken: token } = await instance.acquireTokenSilent({
                account: acc,
                scopes: apiRequest.scopes
            });
            return token;
        }
        return ""
    }


  const onPageChange = (page:number,perpage:number) => {
   

    if(perpage !== appState.perpage){
        getData(1,perpage)
    }
    else{
      getData(page,appState.perpage)
    }
    
  }

  const searchData = async () => {
    
    let field = dataForm.getFieldsValue()
   
    let parameter = InitHelper.InitialParameter();
      if(requestTypeIds.length > 1){
        setRequestTypeId(0)
      }
      else{
        setRequestTypeId(requestTypeIds[0])
      }

      parameter.requestTypeIds = JSON.parse(JSON.stringify(requestTypeIds))
        if(requestTypeIds.indexOf(RequestType.DestructionCarton) > -1)
        {
            parameter.requestTypeIds.push(RequestType.ExtendCarton);
      }
      parameter.statusIds = [
          CartonStatus.WaitApproval,
          CartonStatus.WaitAdmin,
          CartonStatus.Inprogress,
          CartonStatus.Cancel,
          CartonStatus.Reject,
          CartonStatus.Approve,
          CartonStatus.Done
      ]
      parameter.cartonLocation = warehouseId
      
        //parameter.warehouseId = warehouseId

        if(requestStartDate && requestEndDate)
        {
            parameter.requestStartDate = new Date(new Date(requestStartDate).getFullYear(),0,1)
            parameter.requestEndDate = new Date(new Date(requestEndDate).getFullYear(),11,31)
        }
       
    if(field.requestNo){
        parameter.requestNoList = field.requestNo.trim().split(',')
    }
    
      if (field.statusId && field.statusId.length>0){
        parameter.statusIds = field.statusId
      }

    if(requesters.length > 0){
      parameter.requesters = requesters.map(item => item.key)
    }
    
    if(owners.length > 0){
      parameter.owners = owners.map(item => item.key)
    }

    if(orgunits.length > 0){
      parameter.orgUnits = orgunits.map(item => item.key)
    }

    let elementStart = document.getElementById('cartonNoStart') as HTMLInputElement
    let elementEnd = document.getElementById('cartonNoEnd') as HTMLInputElement
    let cartonNoStart = ""
    let cartonNoEnd = ""
    if(elementStart){
      cartonNoStart = elementStart.value
    }
    if(elementEnd){
      cartonNoEnd = elementEnd.value
    }

    if(cartonNoStart && cartonNoEnd){
        parameter.cartonNo = cartonNoStart.trim() + '&' + cartonNoEnd.trim()
    }

    if(field.cartonNoList){
        parameter.cartonNo = field.cartonNoList.trim()
    }

    if(field.cartonNo){
        parameter.cartonNo = field.cartonNo.trim()
    }

   
    getData(1,appState.perpage,parameter,true).then(() => {
      stickyHelper.updatePosition()
  
    })

    
  }
  const reset = () => {
    setIsprint(true)
    let elementStart = document.getElementById('cartonNoStart') as HTMLInputElement
    let elementEnd = document.getElementById('cartonNoEnd') as HTMLInputElement

    if(elementStart)
        elementStart.value = ""

    if(elementEnd)
        elementEnd.value = ""

    dataForm.resetFields()
    setRequestTypeId(0)
    setRequestTypeIds(initialRequestTypeIds)
    setOwners([])
    setOrgUnits([])
    setRequesters([])
    setRequestStartDate(null)
    setRequestEndDate(null)

    let parameter = Object.assign({},InitHelper.InitialParameter())
    parameter.requestTypeIds = initialRequestTypeIds
    parameter.statusIds = [
        CartonStatus.WaitApproval,
        CartonStatus.WaitAdmin,
        CartonStatus.Inprogress,
        CartonStatus.Cancel,
        CartonStatus.Reject,
        CartonStatus.Approve,
        CartonStatus.Done
    ]
    getData(1,appState.perpage,parameter,false)
  }

  const onRequestStartDateChange = (date: any) => {
    setRequestStartDate(date);
  }

  const onRequestEndDateChange = (date: any) => {
    setRequestEndDate(date)
  }

  const onFinishPrint = async () => {
    setIsLoadingPrint(true)
    let token = await getToken()
    try{
      await new FileManageService(token).DownloadReport(saveParameter,ExportType.ALL_TRANSACTION);
    }catch(error){
      console.log("🚀 ~ file: ReportAllTransaction.tsx:378 ~ onFinishPrint ~ error:", error)
    }finally{
      setIsLoadingPrint(false)
    }
  }

    const onWarehouseIdChange = (value:string) => {
        setWarehouseId(value)
    }

    
  return (
    <div>
       <div id={stickyElement.search} className='carton-search-top' onClick={ () => stickyHelper.setCollapse()}>
          <span id="arrow-right" className='display-inline'>
              <AiOutlineRight className='carton-search-top-img'/>
          </span>
          <span id="arrow-down" className='display-none'>
            <AiOutlineDown  className='carton-search-top-img'/>
          </span>
          <span>Search</span>
            
        </div>

        <div id={stickyElement.openSearch} className='carton-search-bottom' >
        {isLoadingPrint?<Loading/>:<></>}
        <Form
                {...layout}
                form={dataForm}
                name="search-panel"
                onFinish={onFinish}
                validateMessages={validateMessages}
                labelAlign="left"
                colon={false}
                labelWrap={true}
              >
                <Row>
                  <Col md={11} >
                    <Form.Item name="requestType" label="Request Type" initialValue={0} >
                      <Select 
                        placeholder={MessageCommon.TitleSelect} 
                        onChange={onRequestTypeChange}
                        options={ RequestTypeOption }
                      />
                    </Form.Item>

                    { requestTypeId !== RequestType.NewCarton ?
                    <>
                      <Form.Item name="cartonNoList" label="Carton No (Multiple)" >
                        <Input.TextArea rows={5} placeholder='ex. 03PCS001,03PCS002,03PCS003'/>
                      </Form.Item>
                    
                      <Form.Item name="cartonNo" label="Carton No" >
                        <Input placeholder='ex. 03PCS001'/>
                      </Form.Item>
                      <Form.Item label="Carton No:(Range)" >
                      <table className='w100c'>
                        <tr>
                          <td>
                            <input id="cartonNoStart" className='form-control form-control-sm' placeholder='ex. 03PCS001'/>
                          </td>
                          <td>
                            <Label className='margin-left-10 margin-right-5'>To</Label>
                          </td>
                          <td>
                            <input id="cartonNoEnd" className='form-control form-control-sm' placeholder='ex. 03PCS001'/>
                        
                          </td>
                        </tr>
                      </table>
                      </Form.Item>
                   </>:<></>
                 }
                  { requestTypeId !== RequestType.NewCarton ?
                  <Form.Item name="warehouseId" label="Carton Location"  initialValue={""}>
                    <Select 
                        showSearch
                        onChange={onWarehouseIdChange}
                        placeholder="Please select..." 
                        options={warehouseOptions} 
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                    />
                 </Form.Item>
                :<></>
                    }
                  </Col>
                  <Col md={2} >
                  </Col>
                  <Col md={11} >
                  <Form.Item name="requestNo" label="Request No."  >
                      <Input placeholder="ex. A230001" />
                    </Form.Item>
                    <Form.Item name="requester" label="Requester"  >
                        <EmployeeAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={requesters ? requesters : []}
                            onChange={item => onRequesterSelect(item)}
                            service={onSearchEmployee}
                            minimumTextLength={3}
                        />
                  </Form.Item>
                  <Form.Item name="year" label="Year">
                      <table className='w100c'>
                        <tr>
                          <td>
                            <DatePicker placeholder={MessageCommon.TitleDate}  picker="year"  className='date-picker-full' onChange={onRequestStartDateChange}/>
                          </td>
                          <td>
                            <Label className='margin-left-10 margin-right-10'>To</Label>
                          </td>
                          <td>
                            <DatePicker placeholder={MessageCommon.TitleDate}  picker="year"  className='date-picker-full' onChange={onRequestEndDateChange}/>
                          </td>
                        </tr>
                      </table>
                    </Form.Item>

                    <Form.Item name="owner" label="Owner"  >
                        <EmployeeAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={owners ? owners : []}
                            onChange={item => onOwnerSelect(item)}
                            service={onSearchEmployee}
                            minimumTextLength={3}
                        />
                    </Form.Item>
                    <Form.Item name="orgUnit" label="Org. Unit"  >
                        <OrgUnitAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={orgunits ? orgunits : []}
                            onChange={item => onOrgUnitSelect(item)}
                            service={onSearchOrgUnit}
                            minimumTextLength={2}
                        />
                    </Form.Item>
                    <Form.Item name="statusId" label="Status">
                        <Select 
                          mode="multiple"
                          allowClear
                          placeholder={MessageCommon.TitleSelect}
                          options={[
                            { value: CartonStatus.WaitApproval, label: 'Wait for Approval' },
                            { value: CartonStatus.WaitAdmin, label: "Wait for Admin Service" },
                            { value: CartonStatus.Inprogress, label: 'On Going' },
                            { value: CartonStatus.Done, label: 'Completed Service' },
                            { value: CartonStatus.Reject, label: 'Rejected' },
                            { value: CartonStatus.Cancel, label: 'Cancel' },
                          ]}
                        />
                      </Form.Item>
                  </Col>
                </Row>
          
              </Form>
              <div className='text-center'>
                <Button type="default" className='mr-btn' onClick={() => reset()}  disabled={appState.isLoading}>
                  <AiOutlineSync className='icn-btn' /> Reset
                </Button>
                <Button type="primary" id="search-btn"   onClick={() => searchData()} disabled={appState.isLoading}>
                  <AiOutlineSearch className='icn-btn'/> Search
                </Button>


              </div>
        </div>
        
        <div id={stickyElement.space} className='sticky-space sticky-bg-white display-none'></div>
        <div id={stickyElement.space2} className='sticky-space2 sticky-bg-grey'></div>
                          
        <div id={stickyElement.result}  className='sticky-data-top sticky-border-top sticky-border-left sticky-border-right'>
            
                <div>
                <Button type="primary" htmlType="button" className='mr-btn' disabled={isPrint} onClick={()=>onFinishPrint()}>
                    <AiOutlinePrinter className='icn-btn' />Print
                </Button>
                </div>
              
                <div className='search-result'>Search found { appState.total } record(s).</div>
              
        </div>
        
        <div id={stickyElement.dataFixed} className='sticky-data-bottom sticky-border-bottom sticky-border-left sticky-border-right'>
        <div id={stickyElement.container} >
        { appState.isLoading ?
            <div className='margin-auto padding-bottom-30'>
              <Spin tip="Loading" size="large">
                <div className="content" />
              </Spin>
            </div>
          :
          	
          <table className='idoc-table'>
            <thead id={stickyElement.data}>
              <tr>
                <th className="thfix1 text-center w50 font075em">No.</th>
                <th className="s-th thfix2 font075em">Request Type</th>
                <th className="s-th font075em">Request No.</th>
                { requestTypeId === RequestType.ReturnCarton ||  requestTypeId === RequestType.RemoveCarton?
                  <th className="s-th font075em">Collect Request No.</th>:<></>
                }
                <th className="s-th font075em">Request Date</th>
                <th className="s-th font075em">Complete Date</th>
                { requestTypeId === 0 || requestTypeId !== RequestType.NewCarton ?
                  <>
                    <th className="s-th font075em">Carton No.</th>
                    <th className="s-th font075em">Carton Location</th>
                  </>:<></>
                }
                <th className="s-th font075em">Requester</th>
                { requestTypeId === 0 || requestTypeId !== RequestType.NewCarton ?
                  <th className="s-th font075em">Owner</th>:<></>
                }
                <th className="s-th font075em">Org Unit.</th>
                { requestTypeId === 0 || requestTypeId === RequestType.CollectCarton || requestTypeId === RequestType.ReturnCarton ?
                  <th className="s-th font075em">Expected Return Date</th>:<></>
                }
                { requestTypeId === 0 || requestTypeId === RequestType.ReturnCarton ?
                  <th className="s-th font075em">Return Date</th>:<></>
                }
                
                <th className="s-th font075em">Carton Quantity</th>
                <th className="s-th font075em">Status</th>
                <th className="s-th font075em">Remark</th>
              </tr>
            </thead>
           
            <tbody >
            { appState.items.map((item:QueryDataModel,index) => (
                <tr>
                  <td  className="tdfix1 text-center w50 font08em">{((appState.currentPage -1) * appState.perpage) + index + 1} </td>
                  
                  <td className="s-td tdfix2 text-center font08em">{item.requestType}</td>
                  <td className="s-td text-center font08em">{item.requestNo}</td>
                  { requestTypeId === RequestType.ReturnCarton || requestTypeId === RequestType.RemoveCarton?
                    <td className="s-td text-center font08em">{item.cartonStatus !== "Storage" ? item.collectRequestNo : "-"}</td>:<></>
                  }
                  <td className="s-td text-center font08em">{ dayjs(item.requestDate).format('DD MMM YYYY') }</td>
                  <td className="s-td text-center font08em">{item.closeJobDate ? dayjs(item.closeJobDate).format('DD MMM YYYY') : "-"}</td>
                  { requestTypeId === 0 || requestTypeId !== RequestType.NewCarton ?
                    <>
                      <td className={(item.storageCartonStatusId === CartonStatus.Remove || item.storageCartonStatusId === CartonStatus.Destruction) ? 's-td text-center break-word font08em c-red' : 's-td text-center break-word font08em'}>{item.cartonNo}</td>
                      { item.cartonLocation ? 
                      <td className="s-td text-left break-word font08em">{item.cartonLocation}</td>
                      : <td className="s-td text-center font08em">-</td>
                      }
                    </>:<></>
                  }
                  <td className="s-td text-left break-word font08em">{item.requesterName}</td>
                  { requestTypeId === 0 || requestTypeId !== RequestType.NewCarton ?
                    <td className="s-td text-left break-word font08em">{item.ownerName}</td>:<></>
                  }
                  <td className="s-td text-center font08em">{item.orgUnit}</td>
                  { requestTypeId === 0 || item.requestTypeId === RequestType.CollectCarton || requestTypeId === RequestType.ReturnCarton ? 
                    <td className="s-td text-center font08em">
                    { item.expectReturnDate ? dayjs(item.expectReturnDate).format('DD MMM YYYY')  : "-"}
                    </td>
                    :<></>
                  }
                { requestTypeId === 0 || item.requestTypeId === RequestType.ReturnCarton ? 
                    <td className="s-td text-center font08em">
                    { item.returnDate ? dayjs(item.returnDate).format('DD MMM YYYY')  : "-"}
                    </td>
                    :<></>
                  }
                  
                  <td className="s-td text-center font08em">{item.quantity}</td>
                  <td className="s-td text-center font08em">{item.status}</td>
                    <td className="s-td text-left break-word font08em">{item.remark}</td>
                </tr>
              ))
            }
            
            </tbody>
  
          </table>
        }
        </div>
        <div className='margin-top-10 text-right'>
        { appState.total > 0 ?
           <Pagination 
           key={Helper.Uniqid()}
           current={appState.currentPage} 
           pageSize={appState.perpage}
           total={appState.total} 
           showSizeChanger={true} 
           pageSizeOptions={pageSizeOptions}
           onChange={onPageChange} 
          />:<></>
          }
        </div>
        </div>

        <input type="hidden" id={stickyElement.clientHight} defaultValue={clientHeight}/>
        
      
    </div >
  );

}

export default ReportAllTransaction
